import React from "react";
import SelectField, { Props } from "./SelectField";
import { KmsRegistrationType } from "@kaltura/mediaspace-shared-types";
import { translate } from "@kaltura/mediaspace-shared-utils";

/**
 * registration type select field for site-registration form
 */
const RegistrationTypeField = React.forwardRef<HTMLInputElement, Props>((props, selectRef) => {
    const options = [
        {
            label: translate("Attend in Person"),
            value: KmsRegistrationType.inPersonAttendanceRequest,
        },
        {
            label: translate("Attend Online"),
            value: KmsRegistrationType.virtualAttendanceRequest,
        },
        { label: translate("Both"), value: KmsRegistrationType.both },
    ];

    return <SelectField {...props} autocompleteMatch={true} options={options} ref={selectRef} />;
});

export default RegistrationTypeField;
